import { render, staticRenderFns } from "./DishCard.vue?vue&type=template&id=f02dd352&scoped=true&"
import script from "./DishCard.vue?vue&type=script&lang=js&"
export * from "./DishCard.vue?vue&type=script&lang=js&"
import style0 from "./DishCard.vue?vue&type=style&index=0&id=f02dd352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02dd352",
  null
  
)

export default component.exports